// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContactUs_form__Sszyh {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ContactUs_inputs__V8n-i {
  display: flex;
  column-count: 2;
  width: 100%;
  gap: 20px;
}

.ContactUs_inputsresiliation__oHNRq {
  display: flex;
  column-count: 2;
  width: 100%;
  gap: 20px;
}

.ContactUs_select__oJM3R {
  width: 50%;
}

.ContactUs_textarea__E8RAm {
  height: 300px;
  margin: 20px 0 40px;
}

.ContactUs_button__e4lMM {
  width: 96px;
}

.ContactUs_close__pWtJJ {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  cursor: pointer;
}

.ContactUs_modal-title__b0tC4 {
  margin-bottom: 20px;
  font-weight: 400;
  font-size: 20px;
  color: #00007a;
}

.ContactUs_modal-text__JaVUE {
  font-size: 14px;
  font-weight: "normal";
  color: #00007a;
  text-align: "center";
  margin-bottom: 10px;
}
.ContactUs_modal-text__JaVUE span {
  font-weight: bold;
}

.ContactUs_modal-button__CRBVT {
  width: 300px;
  margin: 10px 10px 0 10px;
}
.ContactUs_modal-button__CRBVT:first-of-type {
  margin-top: 20px;
}

.ContactUs_closestTerminationDate__9Njn9 {
  width: 100%;
  margin-top: 10px;
  font-size: 12px;
  color: #00007a;
  text-decoration: underline;
  text-align: center;
}
.ContactUs_closestTerminationDate__9Njn9 span {
  display: block;
  font-size: 16px;
  text-align: center;
  margin-top: 10px;
}

.ContactUs_success-message__U9mIC {
  margin-bottom: 10px;
}

@media screen and (max-width: 600px) {
  .ContactUs_inputs__V8n-i {
    flex-direction: column;
    gap: 16px;
  }
  .ContactUs_select__oJM3R {
    width: 100%;
  }
  .ContactUs_textarea__E8RAm {
    margin: 16px 0 28px;
  }
  .ContactUs_button__e4lMM {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ContactUs/ContactUs.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAIF;;AADA;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;AAIF;;AADA;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;AAIF;;AADA;EACE,UAAA;AAIF;;AADA;EACE,aAAA;EACA,mBAAA;AAIF;;AADA;EACE,WAAA;AAIF;;AADA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;AAIF;;AADA;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,cCzCS;AD6CX;;AADA;EACE,eAAA;EACA,qBAAA;EACA,cC/CS;EDgDT,oBAAA;EACA,mBAAA;AAIF;AAFE;EACE,iBAAA;AAIJ;;AAAA;EACE,YAAA;EACA,wBAAA;AAGF;AADE;EACE,gBAAA;AAGJ;;AACA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,cCrES;EDsET,0BAAA;EACA,kBAAA;AAEF;AAAE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAEJ;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE;IACE,sBAAA;IACA,SAAA;EACF;EAEA;IACE,WAAA;EAAF;EAGA;IACE,mBAAA;EADF;EAIA;IACE,WAAA;EAFF;AACF","sourcesContent":["@use 'styles/colors.scss';\n@use 'styles/sizes.scss';\n\n.form {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.inputs {\n  display: flex;\n  column-count: 2;\n  width: 100%;\n  gap: 20px;\n}\n\n.inputsresiliation {\n  display: flex;\n  column-count: 2;\n  width: 100%;\n  gap: 20px;\n}\n\n.select {\n  width: 50%;\n}\n\n.textarea {\n  height: 300px;\n  margin: 20px 0 40px;\n}\n\n.button {\n  width: 96px;\n}\n\n.close {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  display: flex;\n  cursor: pointer;\n}\n\n.modal-title {\n  margin-bottom: 20px;\n  font-weight: 400;\n  font-size: 20px;\n  color: colors.$primary8;\n}\n\n.modal-text{\n  font-size: 14px;\n  font-weight: 'normal';\n  color: colors.$primary8;\n  text-align: 'center';\n  margin-bottom: 10px;\n\n  span{\n    font-weight: bold;\n  }\n}\n\n.modal-button {\n  width: 300px;\n  margin: 10px 10px 0 10px;\n\n  &:first-of-type{\n    margin-top: 20px;\n  }\n}\n\n.closestTerminationDate {\n  width: 100%;\n  margin-top: 10px;\n  font-size: 12px;\n  color: colors.$primary8;\n  text-decoration: underline;\n  text-align: center;\n\n  span{\n    display: block;\n    font-size: 16px;\n    text-align: center;\n    margin-top: 10px;\n  }\n}\n\n.success-message{\n  margin-bottom: 10px;\n}\n\n@media screen and (max-width: sizes.$breakpoint-sm) {\n  .inputs {\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .select {\n    width: 100%;\n  }\n\n  .textarea {\n    margin: 16px 0 28px;\n  }\n\n  .button {\n    width: 100%;\n  }\n}\n","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"form": `ContactUs_form__Sszyh`,
	"inputs": `ContactUs_inputs__V8n-i`,
	"inputsresiliation": `ContactUs_inputsresiliation__oHNRq`,
	"select": `ContactUs_select__oJM3R`,
	"textarea": `ContactUs_textarea__E8RAm`,
	"button": `ContactUs_button__e4lMM`,
	"close": `ContactUs_close__pWtJJ`,
	"modal-title": `ContactUs_modal-title__b0tC4`,
	"modal-text": `ContactUs_modal-text__JaVUE`,
	"modal-button": `ContactUs_modal-button__CRBVT`,
	"closestTerminationDate": `ContactUs_closestTerminationDate__9Njn9`,
	"success-message": `ContactUs_success-message__U9mIC`
};
export default ___CSS_LOADER_EXPORT___;
